<template>
  <div class="d-flex flex-column text-md-center">
    <b-button id="popoverButton-event2">
      <div class="pb-2">
        <fa-icon :icon="['fas', 'ellipsis-v']" />
      </div>
    </b-button>

    <b-popover
      ref="navbarEllipsisPopover"
      target="popoverButton-event2"
      placement="down"
      triggers="click blur"
    >
      <div class="more-menu">
        <div
          v-for="(module, index) in otherModules"
          :key="index"
          class="text-left"
        >
          <b-button
            class="dropdown-item"
            :to="{ name: module.routeName }"
            @click="$refs.navbarEllipsisPopover.$emit('close')"
          >
            <b-row class="more-menu-item px-4">
              <b-col
                cols="3"
                class="d-flex justify-content-center pr-0"
              >
                <i
                  class="more-menu-icon mr-4 main"
                  :class="module.icon"
                  aria-hidden="true"
                />
              </b-col>
              <b-col class="d-flex justify-content-start pl-0">
                <b-button class="dropbtn">
                  {{ module.label }}
                </b-button>
              </b-col>
            </b-row>
          </b-button>
        </div>
      </div>
    </b-popover>
  </div>
</template>

<script>

export default {
    name: 'Dropdownpoints',
    components: {
    },
    props: {
        otherModules: { type: Array }
    },
    data() {
        return {
            isActive: false
        }
    }
}

</script>

<style lang="scss">

.alert-nav {
  .popover-body {
    padding: 0;
  }
}

.popover-body{
    padding: 0 !important;
}

</style>

<style scoped lang="scss">

.dropdown-item{
  padding: 0;
  margin: 0;
  width: 100%;
  border-radius: 0;

    &.router-link-active {
        position: relative;
        &:before {
            content: '';
            position: absolute;
            width: 5px;
            height: 100%;
            background: vt-color(primary);
        }
    }
}

.dropbtn{
  background: transparent;
  border: transparent;
  padding: 0;
  margin: 0 0 0 8px;
  color: vt-color(negative-text);
}

.dropbtn:active{
  background-color: transparent !important;
  border: transparent !important;
  color: vt-color(negative-text) !important;
}

.dropbtn:focus{
  background: transparent;
  border: transparent;
}

.alerts-pop-content {
  width: 300px;
  padding: .5rem .75rem;
}

.alerts-pop-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.alerts-pop-title {
  margin-right: .5rem;
  font-weight: bold;
}

#popoverButton-event2{
    background:none;
    border: none;
    margin: 0;
    padding: 0;
    width: 28px;
}

.more-menu{
  overflow: hidden;
  background: vt-color(popover-bg);
  color: #303133;
  min-width: 240px;
  z-index: 1000;
}

.more-menu li{
  transition: .3s;
  font-size: 0.9rem;
  list-style: none;
}

.more-menu li:hover{
  cursor: pointer;
}

.more-menu .more-menu-collapse{
  float: right;
  margin-top: 3%;
}

.more-menu-icon{
  font-size: font-size(very-big);
  margin-left: 0.7rem;
}

.more-menu .more-menu-item{
  padding: 0.7rem;
  border-bottom: 1px solid vt-color(card-border);
}

.more-menu-item-conf{
  background: vt-color(primary);
  color: #FFF;
  text-align: right;
  padding: 0.3rem;
  transition: .3s;
}

.more-menu-item-conf:hover{
  background: vt-color(dark-primary);
}

.more-menu-sub {
  background: #f2f2f2;
  display: block;
  overflow: hidden;
  width: 100%;
  max-height: 0em;
  opacity: 0;
  transition: max-height 0.3s;
}

.actived{
  opacity: 1;
  max-height: 50em;
}

.arrowactived{
  transform: rotate(180deg) !important;
}

.more-menu-sub li{
  transition: .3s;
  font-size: 0.9rem;
  padding: 4% 10%;
  color: #707070;
}

.more-menu-collapse{
  transform: rotate(0deg);
  transition: 0.3s;
}

.more-menu-item span{
  margin-left: 0.5rem;
}

</style>
